// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"5805be18","314":"6a16c662","421":"74caba28","455":"fdf7abfc","609":"82b7a85e","685":"552b8cb4","768":"48820cc2","826":"25f507c8","845":"edcafd9b","912":"bf3069de","977":"1683e082"}[chunkId] + ".chunk.js";
};